/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Invalid_DateInputs */

const en_us2_onboarding_invalid_date = /** @type {(inputs: Onboarding_Invalid_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a valid date.`)
};

const pt_br2_onboarding_invalid_date = /** @type {(inputs: Onboarding_Invalid_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite uma data válida.`)
};

const es_419_onboarding_invalid_date = /** @type {(inputs: Onboarding_Invalid_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escribe una fecha válida.`)
};

const pt_pt2_onboarding_invalid_date = /** @type {(inputs: Onboarding_Invalid_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduz uma data válida.`)
};

const fr_fr2_onboarding_invalid_date = /** @type {(inputs: Onboarding_Invalid_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisis une date valide.`)
};

const de_de2_onboarding_invalid_date = /** @type {(inputs: Onboarding_Invalid_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib ein gültiges Datum ein.`)
};

const it_it2_onboarding_invalid_date = /** @type {(inputs: Onboarding_Invalid_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci una data valida.`)
};

/**
* | output |
* | --- |
* | "Enter a valid date." |
*
* @param {Onboarding_Invalid_DateInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_invalid_date = /** @type {((inputs?: Onboarding_Invalid_DateInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Invalid_DateInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_invalid_date(inputs)
	if (locale === "es-419") return es_419_onboarding_invalid_date(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_invalid_date(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_invalid_date(inputs)
	if (locale === "de-DE") return de_de2_onboarding_invalid_date(inputs)
	if (locale === "it-IT") return it_it2_onboarding_invalid_date(inputs)
	return en_us2_onboarding_invalid_date(inputs)
});
export { onboarding_invalid_date as "onboarding.invalid_date" }